import React from "react";
import Typography from "@mui/material/Typography";

const ClientNotesTab = ({ clientData }) => {
  return (
    <div>
      <Typography gutterBottom>
        <Typography variant="h5" gutterBottom style={{fontSize:"1.2857142857142856rem"}}>
          Client Notes
        </Typography>
        {clientData.clientNote}
      </Typography>
      <Typography gutterBottom>
        <Typography variant="h5" gutterBottom style={{fontSize:"1.2857142857142856rem"}}>
          Delivery Note
        </Typography>
        {clientData.clientDeliveryNote}
      </Typography>
    </div>
  );
}

export default ClientNotesTab;
